import { useContext } from 'react';

import { DeviceDataContext } from '@/contexts/DeviceDataContext';

export const useDeviceDataContext = () => useContext(DeviceDataContext);
